import m from "../../es2015/lang/el_GR";
window.am4lang_el_GR = m;


//////////////////
// WEBPACK FOOTER
// ./lang/el_GR.js
// module id = null
// module chunks = 